import React, { useContext, useEffect } from 'react';
import { StyleContext } from '../../context/StyleContext';
import { ApiContext } from '../../context/ApiContext';
import { Form } from 'react-bootstrap';
import { FaTimes } from "react-icons/fa";
import {
    Chart as ChartJS,
    LinearScale,
    PointElement,
    Tooltip,
    Legend,
} from 'chart.js';
import { Scatter } from 'react-chartjs-2';

export default function ModalGraficoMatriz({ setModalGrafico }) {
    const { ObterGraficoMatrizTime, GraficoMatrizTime, ObterCapacidade, CapacidadeObter } = useContext(ApiContext)
    const { theme, chartRef } = useContext(StyleContext)

    useEffect(() => {
        ObterGraficoMatrizTime()
        ObterCapacidade()
    }, [])

    const quadrants = {
        id: 'quadrants',
        beforeDraw(chart, args, options) {
            const { ctx, chartArea: { left, top, right, bottom }, scales: { x, y } } = chart;

            const midX = x.getPixelForValue((x.min + x.max) / 2);
            const midY = y.getPixelForValue((y.min + y.max) / 2);

            ctx.save();

            ctx.fillStyle = options.topLeft;
            ctx.fillRect(left, top, midX - left, midY - top);
            ctx.fillStyle = options.topRight;
            ctx.fillRect(midX, top, right - midX, midY - top);
            ctx.fillStyle = options.bottomRight;
            ctx.fillRect(midX, midY, right - midX, bottom - midY);
            ctx.fillStyle = options.bottomLeft;
            ctx.fillRect(left, midY, midX - left, bottom - midY);

            ctx.fillStyle = options.textColor || '#000000';
            ctx.font = '12px sans-serif';

            ctx.fillText("Tolerar", left + 10, top + 20);
            ctx.fillText("Investir", midX + 10, top + 20);
            ctx.fillText("Migrar", midX + 10, midY + 20);
            ctx.fillText("Eliminar", left + 10, midY + 20);

            ctx.restore();
        },
    };

    const eixoLabels = {
        id: 'eixoLabels',
        afterDraw: (chart, args, opts) => {
            const { ctx, chartArea } = chart;
            if (!chartArea) return; 

            const { left, top, right, bottom, width, height } = chartArea;

            ctx.save();

            ctx.font = opts.font || 'bold 14px sans-serif';
            ctx.fillStyle = opts.color || (theme == 'dark' ? '#52525b' : '#ffffff');
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';

            const xLabel = opts.xLabel || 'Pontuação de Negócios';
            const xOffset = typeof opts.xOffset === 'number' ? opts.xOffset : 30; 
            ctx.fillText(xLabel, left + width / 2, bottom + xOffset);

            const yLabel = opts.yLabel || 'Pontuação Técnica';
            const yOffset = typeof opts.yOffset === 'number' ? opts.yOffset : 40; 
            ctx.translate(left - yOffset, top + height / 2);
            ctx.rotate(-Math.PI / 2);
            ctx.fillText(yLabel, 0, 0);

            ctx.restore();
        }
    };

    ChartJS.register(PointElement, LinearScale, Tooltip, Legend, quadrants, eixoLabels);

    const gerarDatasetsMatrizTime = (dados) => {
        return (dados ?? []).map((item) => {
            let x = item.x;
            let y = item.y;

            const margemX = 0.5;
            const margemY = 1.5;

            x = Math.max(margemX, Math.min(25 - margemX, item.x));
            y = Math.max(margemY, Math.min(45 - margemY, item.y));

            return {
                data: [{ x, y, originalX: item.x, originalY: item.y, text: item.text }],
                backgroundColor: item.cor,
                pointRadius: 10,
            };
        });
    };

    const data = {
        datasets: gerarDatasetsMatrizTime(GraficoMatrizTime),
    };


    const options = {
        plugins: {
            quadrants: {
                topLeft: "rgba(138, 181, 78, 0.1)",
                topRight: "rgba(254, 242, 242, 0.2)",
                bottomLeft: "rgba(219, 244, 255, 0.2)",
                bottomRight: "rgba(254, 252, 232, 0.2)",
                textColor: theme == 'dark' ? '#52525b' : '#ffffff'
            },
            eixoLabels: {
                xLabel: 'Pontuação de Negócios',
                yLabel: 'Pontuação Técnica',
                xOffset: 30, 
                yOffset: 40, 
                textColor: theme == 'dark' ? '#52525b' : '#ffffff',
                font: 'bold 14px sans-serif'
            },
            tooltip: {
                callbacks: {
                    title: context => context[0].raw.text,
                    label: context => {
                        const { originalX, originalY } = context.raw;
                        return `x: ${originalX}, y: ${originalY}`;
                    }
                }
            },
            legend: {
                display: false
            }
        },
        layout: {
            padding: {
                left: 60,
                bottom: 60
            }
        },
        scales: {
            x: {
                display: false,
                min: 0,
                max: 25
            },
            y: {
                display: false,
                min: 0,
                max: 45
            }
        },
        showLine: false
    };


    return (
        <div className="modal-novo">
            <div className="modal-novo-interno-matriz-grafico">
                <div className="header-modal">
                    <h1 className="h1-modal">Gráfico Matriz de Avaliação</h1>
                    <div className="btn-close-modal" onClick={() => setModalGrafico(false)}>
                        <FaTimes />
                    </div>
                </div>
                <form>
                    <div className="modal-content">
                        <Form.Group>
                            <Form.Label>Capacidade de Negócio Avaliada</Form.Label>
                            <p className='span-bsc'>{CapacidadeObter?.nivel ? `${CapacidadeObter.nivel} - ` : ''}{CapacidadeObter?.titulo}</p>
                        </Form.Group>
                        <div style={{ height: '400px', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px' }}>
                            <Scatter ref={chartRef} data={data} options={options} plugins={[quadrants, eixoLabels]} />
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}